// view_item
window.addEventListener('ga.view_item', (e) => {
    let gtag = window.gtag || console.log;
    let { category, product} = e.detail;

    let code = `${ _.get(product, 'code', '') }`;
    let productName = `${ _.get(product, 'name', 'default_price.description') }`;
    let item_price = _.get(product, 'item_price');
    let categoryName = _.get(category, 'fullname');
    let nameParts = _.split(categoryName, ' › ');

    let items = [{
        item_id: code,
        item_name: productName,
        // discount: discount,
        index: 0,
        item_category: nameParts[0],
        item_category2: nameParts.length > 1 ? nameParts[1] : null,
        price: item_price,
        quantity: 1
    }];

    gtag('event', 'view_item', {
        currency: 'NZD',
        value: item_price,
        items: items
    });

    // GTM dataLayer
    gtmDataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    gtmDataLayer.push({
        'event': 'view_item',
        'ecommerce': {
            'currency': 'NZD',
            'value': item_price,
            'items': items
        }
    });
});

// category list items
window.addEventListener('ga.view_item_list', (e) => {
    let gtag = window.gtag || console.log;
    let { category, products, query } = e.detail;
    let categoryName = _.get(category, 'fullname');
    let nameParts = _.split(categoryName, ' › ');

    let items = _.chain(products)
        .map((item, index) => {
            return {
                item_id: `${ _.get(item, 'attributes.code') }`,
                item_name: `${ _.get(item, 'attributes.name', 'default_price.description') }`,
                quantity: 1,
                price: `${ _.get(item, 'attributes.price_amount[0]', 0) }`,
                index: index,
                item_category: nameParts[0],
                item_category2: nameParts.length > 1 ? nameParts[1] : null,
            }
        }).value();

    // console.log(query);

    gtag('event', 'view_item_list', {
        item_list_id: 'category_products',
        item_list_name: 'Category products',
        items: items
    });

    // GTM dataLayer
    gtmDataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    gtmDataLayer.push({
        'event': 'view_item_list',
        'ecommerce': {
            'item_list_id': 'category_products',
            'item_list_name': 'Category products',
            'items': items
        },
        'uid.keywords': query
    });

});

// add_to_cart
window.addEventListener('ga.add_to_cart', (e) => {
    let gtag = window.gtag || console.log;
    let { cart, item, item_price} = e.detail;

    let code = `${ _.get(item, 'price.code', '') }`;
    let productName = `${ _.get(item, 'price.description', '') }`;
    let categoryName = `${ _.chain(item)
        .get('product.categories', [])
        .first()
        .get('fullname')
        .value() }`;

    let nameParts = _.split(categoryName, ' › ');

    item_price = parseFloat(item_price).toFixed(2);

    let quantity = `${ _.get(item, 'quantity', 1) }`;

    let itemsAdded = [{
        item_id: code,
        item_name: productName,
        // discount: discount,
        index: 0,
        item_category: nameParts[0],
        item_category2: nameParts.length > 1 ? nameParts[1] : null,
        price: item_price,
        quantity: quantity
    }];

    gtag('event', 'add_to_cart', {
        currency: 'NZD',
        value: item_price,
        items: itemsAdded
    });

    // GTM dataLayer
    gtmDataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    gtmDataLayer.push({
        'event': 'add_to_cart',
        'ecommerce': {
            'currency': 'NZD',
            'value': item_price,
            'items': itemsAdded
        }
    });
});

// view_cart
window.addEventListener('ga.view_cart', (e) => {
    let gtag = window.gtag || console.log;
    let { cart } = e.detail;

    let amount_billed = _.chain(cart)
                        .get('summary.amount_billed')
                        .round(2)
                        .value();

    let items = _.chain(cart)
        .get('items')
        .map((item, index) => {
            return {
                item_id: `${ _.get(item, 'price.code') }`,
                item_name: `${ _.get(item, 'name') }`,
                quantity: `${ _.get(item, 'quantity') }`,
                price: `${ _.get(item, 'item_price', 0) }`,
                index: index,
            }
        }).value();

    // console.log(items);

    gtag('event', 'view_cart', {
        currency: 'NZD',
        value: amount_billed,
        items: items
    });

    // GTM dataLayer
    gtmDataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    gtmDataLayer.push({
        'event': 'view_cart',
        'ecommerce': {
            'currency': 'NZD',
            'value': amount_billed,
            'items': items
        }
    });
});

// Purchase
window.addEventListener('ga.purchase', (e) => {
    let gtag = window.gtag || console.log;
    let { cart, order } = e.detail;

    // GA4 ecommerce products
    let itemsPurchased = _.chain(order).get('items')
        .map((item, index) => {

            return {
                item_id: `${ _.get(item, 'price_code') }`,
                item_name: `${ _.get(item, 'product_name') }`,
                // item_brand: `${ _.get(item, 'product.brand_name', '') }`,
                quantity: `${ _.get(item, 'quantity') }`,
                price: `${ _.get(item, 'item_price', 0) }`,
                index: index,
            }
        }).value();

    gtag('event', 'purchase', {
        transaction_id: `${ order.id }`,
        affiliation: `${ window.env['APP_NAME'] }`,
        value: `${ _.get(order, 'amount_billed') }`,
        tax: `${ _.get(order, 'gst') }`,
        shipping: `${ _.get(order, 'freight_total') }`,
        currency: 'NZD',
        coupon: `${ _.get(order, 'discount_code', '') }`,
        // GA4 ecommerce products
        items: itemsPurchased,

        // UA format
        products: _.chain(order).get('items')
            .map((item, index) => {

                return {
                    id: `${ _.get(item, 'price_code') }`,
                    name: `${ _.get(item, 'product_name') }`,
                    // brand: `${ _.get(item, 'product.brand_name', '') }`,
                    quantity: `${ _.get(item, 'quantity') }`,
                    price: `${ _.get(item, 'item_price') }`,
                    index: index,
                }
            }).value(),
    });

    // GTM dataLayer
    gtmDataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    gtmDataLayer.push({
        'event': 'purchase',
        'ecommerce': {
            'transaction_id': `${ order.id }`,
            'affiliation': `${ window.env['APP_NAME'] }`,
            'value': `${ _.get(order, 'amount_billed') }`,
            'tax': `${ _.get(order, 'gst') }`,
            'shipping': `${ _.get(order, 'freight_total') }`,
            'currency': 'NZD',
            'coupon': `${ _.get(order, 'discount_code', '') }`,
            'items': itemsPurchased
        }
    });
});